module.exports = __webpack_public_path__ + "img/023.cfe555b9.jpg";